function UnfoldLogo() {
    const svgContent = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 432 129.6"
            className="h-auto w-full"
        >
            <defs>
                <clipPath id="clippath">
                    <path
                        className="fill-none"
                        d="M72.52,62.53l20.03-16.87-19.25-16.21c-2.01-1.69-4.94-1.69-6.95,0l-37.07,31.22c-2.56,2.16-2.56,6.1,0,8.25l37.22,31.35c1.32,1.11,3.33.17,3.33-1.55v-30.4c0-2.24.99-4.36,2.7-5.8Z"
                    />
                </clipPath>
            </defs>
            <g>
                <path
                    className="fill-[#293d8f]"
                    d="M115.29,30.88v31.42c0,1.59-.7,3.1-1.92,4.13l-40.2,33.86c-1.32,1.11-3.33.17-3.33-1.55v-31.42c0-1.59.7-3.1,1.92-4.13l40.2-33.86c1.32-1.11,3.33-.17,3.33,1.55Z"
                />
                <path
                    className="fill-[#2cceb5]"
                    d="M113.37,66.42l-20.8,17.52,20.12,16.94c1.51,1.27,3.71,1.27,5.21,0l39.17-32.99c1.92-1.62,1.92-4.57,0-6.19l-38.45-32.38c-1.32-1.11-3.33-.17-3.33,1.55v31.42c0,1.59-.7,3.1-1.92,4.13Z"
                />
                <path
                    className="fill-[#6e43b1]"
                    d="M92.56,83.94l-18.29-15.4c-1.75-1.48-4.43-.23-4.43,2.06v28.13c0,1.72,2.01,2.65,3.33,1.55l19.4-16.34Z"
                />
                <path
                    className="fill-[#293d8f]"
                    d="M115.29,33.14h0c0-1.82,1.48-3.3,3.3-3.3h.62l-2.18-1.84c-1-.85-2.47-.85-3.47,0l-2.18,1.84,3.92,3.3Z"
                />
                <path
                    className="fill-[#6e43b1]"
                    d="M69.84,96.47h0c0,1.82-1.48,3.3-3.3,3.3h-.62l2.18,1.84c1,.85,2.47.85,3.47,0l2.18-1.84-3.92-3.3Z"
                />
                <g style={{ clipPath: "url(#clippath)" }}>
                    <path
                        className="fill-[#9145c1]"
                        d="M147.3,29.99L37.2,122.18l3.15,3.75,110.09-92.19-3.15-3.75Z"
                    />
                    <path
                        className="fill-[#9145c1]"
                        d="M134.56,27.03L24.47,119.21l3.15,3.75L137.71,30.77l-3.15-3.75Z"
                    />
                    <path
                        className="fill-[#9145c1]"
                        d="M121.81,24.06L11.72,116.24l3.15,3.75L124.96,27.8l-3.15-3.75Z"
                    />
                    <path
                        className="fill-[#9145c1]"
                        d="M109.06,21.09L-1.03,113.27l3.15,3.75L112.21,24.83l-3.15-3.75Z"
                    />
                    <path
                        className="fill-[#9145c1]"
                        d="M96.32,18.12L-13.77,110.3l3.15,3.75L99.47,21.86l-3.15-3.75Z"
                    />
                    <path
                        className="fill-[#9145c1]"
                        d="M83.58,15.14L-26.51,107.33l3.15,3.75L86.72,18.89l-3.15-3.75Z"
                    />
                </g>
            </g>
            <g>
                <path
                    className="fill-[#04063e]"
                    d="M182.75,42.4v24.36c0,3.3.42,6.42,2.22,8.82,1.8,2.46,4.62,3.96,8.52,3.96s6.72-1.5,8.52-3.96c1.8-2.4,2.22-5.52,2.22-8.82v-24.36h7.38v24.84c0,4.68-.9,9.48-3.96,13.2-3.06,3.72-8.04,6.06-14.28,6.06s-11.22-2.28-14.28-6.06c-3.12-3.72-3.96-8.46-3.96-13.2v-24.84h7.62Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M216.37,56.2h7.2v2.94l.12.06c2.4-2.1,5.76-3.66,9.72-3.66,3.24,0,5.82,1.02,7.74,3.06,1.86,2.04,2.58,4.68,2.58,8.64v18.6h-7.26v-17.7c0-2.1-.3-3.66-1.32-4.68s-2.46-1.5-4.08-1.5c-2.76,0-5.58,1.38-7.44,3.24v20.64h-7.26v-29.64Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M249.76,62.44h-4.5v-6.24h4.5v-6.12c0-7.08,3.42-10.74,9.9-10.74,1.98,0,4.02.36,5.34.96v5.94c-1.14-.36-2.58-.66-3.84-.66-3.12,0-4.14,1.8-4.14,4.98v5.64h7.32v6.24h-7.32v23.4h-7.26v-23.4Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M263.79,71.02c0-8.76,6.84-15.48,16.02-15.48s16.02,6.72,16.02,15.48-6.84,15.48-16.02,15.48-16.02-6.78-16.02-15.48ZM288.57,71.02c0-5.1-3.78-9.12-8.76-9.12s-8.76,4.02-8.76,9.12,3.72,9.06,8.76,9.06,8.76-3.96,8.76-9.06Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M298.95,40h7.26v45.84h-7.26v-45.84Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M331.75,83.86l-.12-.06c-2.04,1.62-4.86,2.7-8.16,2.7-7.5,0-13.92-5.76-13.92-15s6.48-15.96,15.42-15.96c2.58,0,4.68.66,6.54,1.44l.12-.06v-16.92h7.26v45.84h-7.14v-1.98ZM331.63,77.98v-14.64c-1.62-.9-3.66-1.56-5.94-1.56-5.64,0-8.82,4.26-8.82,9.48s3.12,9.12,8.4,9.12c2.58,0,4.68-1.02,6.36-2.4Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M370.57,42.4h7.74l17.58,43.44h-8.16l-4.2-10.62h-18.54l-4.2,10.62h-7.8l17.58-43.44ZM381.13,68.98l-2.28-6c-1.44-3.84-3.18-8.64-4.38-12.06h-.12c-1.26,3.54-3,8.16-4.56,12.12l-2.34,5.94h13.68Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M397.02,42.4h7.62v43.44h-7.62v-43.44Z"
                />
                <path
                    className="fill-[#04063e]"
                    d="M216.37,56.2h7.2v2.94l.12.06c2.4-2.1,5.76-3.66,9.72-3.66,3.24,0,5.82,1.02,7.74,3.06,1.86,2.04,2.58,4.68,2.58,8.64v18.6h-7.26v-17.7c0-2.1-.3-3.66-1.32-4.68s-2.46-1.5-4.08-1.5c-2.76,0-5.58,1.38-7.44,3.24v20.64h-7.26v-29.64Z"
                />
            </g>
        </svg>
    );

    return (
        <div id="unfold-logo" className="w-41">
            {svgContent}
        </div>
    );
}

export default UnfoldLogo;
